import { render, staticRenderFns } from "./my-pagination.vue?vue&type=template&id=6bbbc06b&"
import script from "./my-pagination.vue?vue&type=script&lang=ts&"
export * from "./my-pagination.vue?vue&type=script&lang=ts&"
import style0 from "./my-pagination.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports